import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Cotista } from "./cotista.model";

export class Subscricao extends BaseEntity{
    public id:number;
    public cotista: Cotista;
    public categoriaCota:string;
    public numeroCota:number;
    public dataSubscricao:Date;
    public dataAtualizacao:Date;
    public valor:number;
    public usuarioADResponsavel:string;
    public nomeUsuarioADResponsavel: string;
    public dataRegistro:Date;
    public numeroConglomerado: string;
}
